import moment from 'moment-timezone';

(() => {
  class OutboundCallTableController {
    constructor(ngDialog, Utils) {
      'ngInject';

      Object.assign(this, {
        ngDialog,
        Utils
      });
    }

    formatDate(iso_date) {
      if (!iso_date) return null;
      let formatted_date = moment.tz(iso_date, this.timezone).format('DD/MMM/YY h:mm A');
      return formatted_date;
    }

    showDetails(outboundVisit) {
      this.openOutboundCallForm(outboundVisit, response => {
        if (response && response.success) {
          // Details updated
          // We need to refresh the list
          this.onPageChange();
        } else {// User closed the popup
          // Do nothing
        }
      });
    }

    openOutboundCallForm(outboundVisit, callback) {
      return this.ngDialog.open({
        template: 'app/components/outbound-call-form/outbound-call-form.html',
        // To not allow the user closes the modal without explicitely to have some action
        // select the X to close
        // closeByEscape: false,
        // closeByNavigation: false,
        // closeByDocument: false,
        // To make possible doctor still be able to use the screen behind
        // overlay: false,
        controller: 'OutboundCallFormController',
        controllerAs: '$ctrl',
        className: 'ngdialog-theme-default lemonaid-pharmacy-form-modal',
        data: {
          outboundVisit
        },

        /**
         * @param {string|object} res - res will be an object if a pharmacy is selected
         */
        preCloseCallback(res) {
          if (typeof res === 'object') {
            return callback(res);
          }

          return callback(false);
        }

      });
    }

  }

  OutboundCallTableController.$inject = ["ngDialog", "Utils"];
  angular.module('pims').component('outboundCallTable', {
    templateUrl: 'app/components/outbound-call-table/outbound-call-table.html',
    controller: OutboundCallTableController,
    bindings: {
      pagination: '=',
      sortBy: '=',
      sortOrder: '=',
      onPageChange: '&',
      onSort: '&',
      outboundVisits: '<'
    }
  });
})();
